import React, { useState } from "react";
import { useEffect } from "react";
import AOS from "aos";
import "./Tournament.css";
import { Container, Col, Row, Image } from "react-bootstrap";
import axios from "axios";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";
import deleteicon from "../assets/img/delete.png";
import Alert from "../assets/img/alert.png";

export default function FriendlyMatchCards() {
  const [show, setShow] = useState(false);
  const [teamName, setTeamName] = useState("");
  const [clanId, setClanId] = useState("");
  const [townhallLevel, setTownhallLevel] = useState("");
  const [members, setMembers] = useState("");
  const [telegramLink, settelegramLink] = useState("");
  const [instagramLink, setinstagramLink] = useState("");
  const [allDetails, setAllDetails] = useState(true);
  const [linkDetails, setLinkDetails] = useState(true);
  const [memberCheck, setMemberCheck] = useState(true);
  const [buttonText, setButtonText] = useState("Add");
  const [showA, setShowA] = useState(false);
  const [showB, setShowB] = useState(false);
  const [dashow, setDaShow] = useState(false);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [showDeleteFail, setShowDeleteFail] = useState(false);
  const [todeleteId, setTodeleteId] = useState("");
  const [loader, setLoader] = useState(false);

  const toggleShowDeleteSuccess = () =>
    setShowDeleteSuccess(!showDeleteSuccess);
  const toggleShowDeleteFail = () => setShowDeleteFail(!showDeleteFail);

  const toggleShowA = () => setShowA(!showA);
  const toggleShowB = () => setShowB(!showB);
  const handleClose = () => {
    setShow(false);
    setAllDetails(true);
    setLinkDetails(true);
    setMemberCheck(true);
    setTeamName("");
    setClanId("");
    setTownhallLevel("");
    setMembers("");
    settelegramLink("");
    setinstagramLink("");
  };
  const handleDClose = () => setDaShow(false);

  const handleDShow = (id) => {
    // console.log(id);
    setTodeleteId(id);
    setDaShow(true);
  };
  const handleShow = () => setShow(true);
  const [friendlyMatches, setFriendlyMatches] = useState([]);

  useEffect(() => {
    setLoader(true);
    AOS.init();

    getFriendlyMatches();
  }, []);
  function handleTeamNameChange(event) {
    setTeamName(event.target.value);
  }
  function handleClanIdChange(event) {
    setClanId(event.target.value);
  }
  function handleTownHallLevelChange(event) {
    setTownhallLevel(event.target.value);
  }
  function handleMembersChange(event) {
    setMembers(event.target.value);
  }
  function handleTelegramLinkChange(event) {
    settelegramLink(event.target.value);
  }
  function handleInstagramLinkChange(event) {
    setinstagramLink(event.target.value);
  }
  async function deleteFriendlyMatch(id) {
    await axios
      .delete(
        `https://vickygaming.onrender.com/api/v1/friendlymatches/${todeleteId}`
      )
      .then((response) => {
        setTodeleteId("");
        handleDClose();
        toggleShowDeleteSuccess();
        getFriendlyMatches();
      })
      .catch((error) => {
        setTodeleteId("");
        handleDClose();
        toggleShowDeleteFail();
        console.log(error);
      });
  }
  async function handleSubmit() {
    if (!teamName || !clanId || !townhallLevel || !members) {
      setAllDetails(false);
      return;
    }
    setAllDetails(true);
    if (!telegramLink && !instagramLink) {
      setLinkDetails(false);
      return;
    }
    setLinkDetails(true);
    let membersCount = Number(members);
    if (membersCount !== 5 && membersCount !== 10) {
      setMemberCheck(false);
      return;
    }
    setMemberCheck(true);
    setButtonText("Adding...");
    await axios
      .post(`https://vickygaming.onrender.com/api/v1/friendlymatches`, {
        teamName: teamName,
        clanId: clanId,
        townhallLevel: townhallLevel,
        membersCount: membersCount,
        instagramLink: instagramLink,
        telegramLink: telegramLink,
      })
      .then((response) => {
        setButtonText("Add");
        toggleShowB();
        getFriendlyMatches();
        handleClose();
      })
      .catch((error) => {
        toggleShowA();
        setButtonText("Add");

        console.log(error);
      });
  }
  async function getFriendlyMatches() {
    await axios
      .get(`https://vickygaming.onrender.com/api/v1/friendlymatches`, {
        returnSecureToken: true,
      })
      .then((response) => {
        setFriendlyMatches(response.data.data.FriendlyMatchs);
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  return (
    <section style={{ marginTop: "80px" }}>
      <ToastContainer
        position="bottom-end"
        className="p-3"
        style={{ zIndex: 1 }}
      >
        <Toast
          show={showDeleteFail}
          onClose={toggleShowDeleteFail}
          delay={3000}
          autohide
          bg="danger"
        >
          <Toast.Body>Something went wrong! Please try again later.</Toast.Body>
        </Toast>
      </ToastContainer>

      <ToastContainer
        position="bottom-end"
        className="p-3"
        style={{ zIndex: 1 }}
      >
        <Toast
          show={showDeleteSuccess}
          onClose={toggleShowDeleteSuccess}
          delay={3000}
          autohide
          bg="success"
        >
          <Toast.Body>Successfully Deleted!</Toast.Body>
        </Toast>
      </ToastContainer>
      <Modal show={dashow} onHide={handleDClose} className="mt-5">
        <Modal.Header
          style={{
            background: "rgb(34, 34, 34)",
            color: "#fff",
            borderBottom: "1px solid black",
          }}
        >
          <Modal.Title>
            {" "}
            <span>
              <Image
                src={Alert}
                alt="alerticon"
                style={{ width: "30px", height: "30px", margin: "0px" }}
              />{" "}
            </span>{" "}
            Alert
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            background: "rgb(34, 34, 34)",
            color: "#fff",
          }}
        >
          Are You sure want to delete?
        </Modal.Body>
        <Modal.Footer
          style={{
            background: "rgb(34, 34, 34)",
            color: "#fff",
            borderTop: "1px solid black",
          }}
        >
          <Button variant="secondary" onClick={handleDClose}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteFriendlyMatch(todeleteId)}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show} onHide={handleClose}>
        <Modal.Body style={{ background: "#121212" }}>
          <div className="header text-center">
            <h1>Add Friendly Match</h1>
          </div>
          <div className="form">
            <Form>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Team Name
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="season"
                  value={teamName}
                  placeholder="Team Name"
                  onChange={handleTeamNameChange}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Clan ID
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="season"
                  value={clanId}
                  placeholder="clanid"
                  onChange={handleClanIdChange}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  TownHall Level
                </Form.Label>
                <br />
                <input
                  type="number"
                  name="season"
                  value={townhallLevel}
                  placeholder="15"
                  onChange={handleTownHallLevelChange}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Members Count
                </Form.Label>
                <br />
                <input
                  type="number"
                  name="season"
                  value={members}
                  placeholder="5"
                  onChange={handleMembersChange}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                  required
                />
              </Form.Group>
              {!memberCheck && (
                <p style={{ color: "red" }}>Please enter either 5 or 10</p>
              )}
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Instagram Link
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="season"
                  value={instagramLink}
                  placeholder="https://www.instagram.com/theanishaadvik/"
                  onChange={handleInstagramLinkChange}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Telegram Link
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="season"
                  value={telegramLink}
                  placeholder="https://t.me/username"
                  onChange={handleTelegramLinkChange}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                  required
                />
              </Form.Group>
              {!allDetails && (
                <p style={{ color: "red" }}>Please enter all the details</p>
              )}
              {!linkDetails && (
                <p style={{ color: "red" }}>Please enter atleast one link</p>
              )}
            </Form>
          </div>
          <ToastContainer
            position="bottom-end"
            className="p-3"
            style={{ zIndex: 1 }}
          >
            <Toast
              show={showA}
              onClose={toggleShowA}
              delay={3000}
              autohide
              bg="danger"
            >
              <Toast.Body>
                Something went wrong! Please try again later.
              </Toast.Body>
            </Toast>
          </ToastContainer>

          <ToastContainer
            position="bottom-end"
            className="p-3"
            style={{ zIndex: 1 }}
          >
            <Toast
              show={showB}
              onClose={toggleShowB}
              delay={3000}
              autohide
              bg="success"
            >
              <Toast.Body>Successfully Added!</Toast.Body>
            </Toast>
          </ToastContainer>
        </Modal.Body>
        <Modal.Footer style={{ background: "#121212" }}>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button className="tbutton" onClick={handleSubmit}>
            {buttonText}
          </Button>
        </Modal.Footer>
      </Modal>
      <Container>
        <div className="align-items-center text-center mt-4 mb-4">
          <h2 style={{ fontSize: "28px" }} className="tbtn">
            Friendly Match
          </h2>
        </div>
        <div className="addbutton  mt-5" style={{ marginBottom: "-40px" }}>
          <Button className="tbutton mt-4" onClick={handleShow}>
            Add New
          </Button>
        </div>
        {loader && (
          <div
            className="d-flex align-items-center justify-content-center text-center mb-4"
            style={{ marginTop: "80px" }}
          >
            {" "}
            <div className="wrapper">
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="shadow"></div>
              <div className="shadow"></div>
              <div className="shadow"></div>
            </div>
          </div>
        )}

        <Row xs={1} md={2} lg={3} className="g-4 mt-5 mb-4 align-items-center">
          {friendlyMatches.map((fm, idx) => (
            <Col key={idx}>
              <div className="parent ">
                <div className="fcard">
                  <div className="glass"></div>
                  <div className="content">
                    <span className="title">{fm.teamName}</span>
                    <div className="text">
                      <h6 style={{ fontSize: "18px" }}>
                        {`Clan Id : `}{" "}
                        <span style={{ fontSize: "16px", fontWeight: 400 }}>
                          {fm.clanId}
                        </span>{" "}
                      </h6>
                      <h6 style={{ fontSize: "18px" }}>
                        {`TownHall level : `}{" "}
                        <span style={{ fontSize: "16px", fontWeight: 400 }}>
                          {fm.townhallLevel}
                        </span>{" "}
                      </h6>
                      <h6 style={{ fontSize: "18px" }}>
                        {`Team Size : `}{" "}
                        <span style={{ fontSize: "16px", fontWeight: 400 }}>
                          {fm.membersCount}x{fm.membersCount}
                        </span>{" "}
                      </h6>
                    </div>
                  </div>
                  <div className="bottom">
                    <div className="social-buttons-container">
                      {fm.instagramLink && (
                        <Link to={fm.instagramLink} className="link">
                          <button className="social-button .social-button1">
                            <svg
                              viewBox="0 0 30 30"
                              xmlns="http://www.w3.org/2000/svg"
                              className="svg"
                            >
                              <path d="M 9.9980469 3 C 6.1390469 3 3 6.1419531 3 10.001953 L 3 20.001953 C 3 23.860953 6.1419531 27 10.001953 27 L 20.001953 27 C 23.860953 27 27 23.858047 27 19.998047 L 27 9.9980469 C 27 6.1390469 23.858047 3 19.998047 3 L 9.9980469 3 z M 22 7 C 22.552 7 23 7.448 23 8 C 23 8.552 22.552 9 22 9 C 21.448 9 21 8.552 21 8 C 21 7.448 21.448 7 22 7 z M 15 9 C 18.309 9 21 11.691 21 15 C 21 18.309 18.309 21 15 21 C 11.691 21 9 18.309 9 15 C 9 11.691 11.691 9 15 9 z M 15 11 A 4 4 0 0 0 11 15 A 4 4 0 0 0 15 19 A 4 4 0 0 0 19 15 A 4 4 0 0 0 15 11 z"></path>
                            </svg>
                          </button>
                        </Link>
                      )}
                      {fm.telegramLink && (
                        <Link to={fm.telegramLink} className="link">
                          <button className="social-button .social-button2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="rgba(170, 54, 124)"
                              className="bi bi-telegram svg"
                              viewBox="0 0 16 16"
                            >
                              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
                            </svg>
                          </button>
                        </Link>
                      )}
                    </div>
                    <div className="view-more">
                      <Image
                        src={deleteicon}
                        alt="deleteicon"
                        // className="mt-4"
                        style={{
                          width: "30px",
                          height: "30px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleDShow(fm._id)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}
